import React from 'react';

type FlagIconProps = {
  width?: string;
  height?: string;
};

export const FlagIcon = ({ width = '17px', height = '17px' }: FlagIconProps) => (
  <svg width={width} height={height} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.2248 7.49984L18.3346 13.3332H3.33464V18.3332H1.66797V1.6665H18.3346L15.2248 7.49984ZM3.33464 3.33317H15.5574L13.3361 7.49984L15.5574 11.6665H3.33464V3.33317Z"
      fill="#3659E3"
    />
  </svg>
);
